module.exports = __webpack_public_path__ + "img/Uruguay.b5394431.png";